// src/components/infografia/toolbar/Toolbar.jsx
import React from 'react';
import { FaFont, FaImage, FaQrcode, FaShapes, FaIcons } from 'react-icons/fa';

const Toolbar = ({ onAddElement }) => {
    const tools = [
        { id: 'texto', icon: FaFont, label: 'Texto', color: 'text-blue-600' },
        { id: 'imagen', icon: FaImage, label: 'Imagen', color: 'text-green-600' },
        { id: 'qr', icon: FaQrcode, label: 'QR Code', color: 'text-purple-600' },
        { id: 'formas', icon: FaShapes, label: 'Formas', color: 'text-orange-600' },
        { id: 'icono', icon: FaIcons, label: 'Icono', color: 'text-indigo-600' }
    ];

    return (
        <div className="flex flex-col items-center py-4 space-y-4">
            {tools.map((tool) => {
                const Icon = tool.icon;
                return (
                    <button
                        key={tool.id}
                        onClick={() => onAddElement(tool.id)}
                        className={`w-12 h-12 flex items-center justify-center rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors ${tool.color}`}
                        title={tool.label}
                    >
                        <Icon className="w-6 h-6" />
                    </button>
                );
            })}
        </div>
    );
};

export default Toolbar;

